import { Box, Chip, Typography } from '@mui/material'

type SectionHeadingPropsType = {
  /** Puce d'exergue posée au-dessus du titre, à la manière des sections des sites vitrines. */
  eyebrow?: string | null
  title: string
  subtitle?: string | null
}

// Motif de section repris des sites vitrines : puce d'exergue, titre en serif de titrage à
// interligne serré, puis un paragraphe en Inter gris. Cf. docs/direction-artistique.md.
const SectionHeading = ({ eyebrow, title, subtitle }: SectionHeadingPropsType) => (
  <Box sx={{ mb: 2.5 }}>
    {eyebrow && (
      <Chip
        label={eyebrow}
        size="small"
        sx={{ mb: 1.5, backgroundColor: 'background.paper', border: 1, borderColor: 'divider' }}
      />
    )}
    <Typography variant="h4" sx={{ maxWidth: 640 }}>
      {title}
    </Typography>
    {subtitle && (
      <Typography variant="body1" sx={{ mt: 1, color: 'text.secondary', maxWidth: 640 }}>
        {subtitle}
      </Typography>
    )}
  </Box>
)

export default SectionHeading
